import { axios } from '@/utils/request'

const api = {
  cashaccountList: '/adminapi/cashaccount/cashaccountList',
  cashaccountLogList: '/adminapi/cashaccount/cashaccountLogList',
  balanceEdit: '/adminapi/cashaccount/balanceEdit',
  blockedEdit: '/adminapi/cashaccount/blockedEdit',
  withdrawlist: '/adminapi/cashaccount/withdrawlist',
  withdrawSuccess: '/adminapi/cashaccount/withdrawSuccess',
  withdrawError: '/adminapi/cashaccount/withdrawError',
}

export default api

export function cashaccountList(parameter) {
  return axios({
    url: api.cashaccountList,
    method: 'get',
    params: parameter
  })
}
export function cashaccountLogList(parameter) {
  return axios({
    url: api.cashaccountLogList,
    method: 'get',
    params: parameter
  })
}
export function withdrawlist(parameter) {
  return axios({
    url: api.withdrawlist,
    method: 'get',
    params: parameter
  })
}
export function balanceEdit(parameter) {
  return axios({
    url: api.balanceEdit,
    method: 'post',
    data: parameter
  })
}
export function blockedEdit(parameter) {
  return axios({
    url: api.blockedEdit,
    method: 'post',
    data: parameter
  })
}
export function withdrawSuccess(parameter) {
  return axios({
    url: api.withdrawSuccess,
    method: 'post',
    data: parameter
  })
}
export function withdrawError(parameter) {
  return axios({
    url: api.withdrawError,
    method: 'post',
    data: parameter
  })
}